<app-bx-header></app-bx-header>
<section class="profileLanding" [class.background-white-override]="showDeleteAccount">
  @if (!showChangePassword && !showDeleteAccount) {
    <div class="landing-container d-flex flex-column gap-48 gap-48-768 px-md-0 py-64-768 px-24 py-32">
      <div class="px-162-768 back-btn-sticky">
        <a [routerLink]="['/dashboard']" class="txt-baseBlue600 d-flex gap-8 align-items-center">
          <img src="/assets/images/chevron-left.svg" alt="chevron-left" class="chevronLeft">
          <span class="paragraph-extra-Medium-768 paragraph-extra-Medium font-medium">Back to dashboard</span>
        </a>
      </div>
      <div class="d-flex flex-column flex-md-row align-items-start profile-landing-wrapper gap-48 gap-48-768">
        <div class="d-flex flex-column gap-32 gap-32-768 details-box">
          <div>
            <h2 class="heading2-768 font-bold heading2 text-black">Account Settings</h2>
            <p class="paragraph-Medium paragraph-Medium-768 open-sans txt-charcoalGrey500">Manage your login details and security settings.</p>
          </div>
          <div class="d-flex flex-column gap-48 gap-48-768">
            <div class="d-flex flex-column column gap-8-768">
              <div class="font-semibold heading4 heading4-768">
                Email address
              </div>
              <div class="row">
                <div>
                  <span class="paragraph-large-768 paragraph-large">{{userEmail}}</span>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column column gap-8 gap-8-768">
              <div class="font-semibold heading4 heading4-768">Password</div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="paragraph-large-768 paragraph-large">********</div>
                <a (click)="openChangePassword()" class="link paragraph-extra-Medium-768 paragraph-extra-Medium border-bottom-primary cursor-pointer">Change password</a>
              </div>
            </div>
            <div class="d-flex flex-column column gap-16 gap-16-768">
              <div class="d-flex flex-column gap-8 gap-8-768">
                <div class="font-semibold heading4 heading4-768">Sign out of all devices</div>
                <div class="paragraph-large-768 paragraph-Medium">
                  This will sign you out everywhere you’re currently logged in. Use this if you’ve shared a device or notice unusual activity.
                </div>
              </div>
              <button class="signout-btn secondary d-flex align-items-center justify-content-center txt-charcoalGrey500 border-grey500 round-100 py-8 px-16 px-16-768 py-8-768 heading6-768 paragraph-extra-Medium font-semibold order-2 order-md-1 no-wrap"
              (click)="signOutAllDevice()">Sign out of all devices</button>
            </div>
            @if (showDeleteAccountCard && !showKeepAccountCard) {
              <div class="d-flex flex-column gap-16 gap-16-768">
                <a class="txt-delete-action paragraph-xsmall-768 paragraph-xsmall font-medium cursor-pointer" (click)="openDeleteAccount()">Delete your account</a>
              </div>
            }
            @if (showKeepAccountCard) {
              <div class="keep-account-card d-flex flex-column gap-24 gap-16-768 p-20 p-24-768 round-16 round-16-768">
                <div class="d-flex flex-column flex-md-row gap-16 gap-16-768 align-items-start">
                  <img src="assets/icons/handshake.svg" alt="settings" class="keep-account-icon round-100">
                  <div class="d-flex flex-column gap-4-0 gap-4-768">
                    <h4 class="heading4-768 heading4 font-semibold text-black">Want to keep your account?</h4>
                    <div class="d-flex flex-column gap-16 gap-16-768">
                      <p class="open-sans paragraph-Medium paragraph-large-768 text-black">Your account will remain accessible until deletion is complete. If you'd like to stop the process, you can cancel your request now.</p>
                      <a class="keep-account-link font-medium paragraph-extra-Medium-768 paragraph-extra-Medium text-black border-bottom-primary cursor-pointer" (click)="cancelDeletionRequest()">Cancel deletion request</a>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div
          class="d-flex flex-column gap-16 gap-16-768 background-white border-rgbaGrey500 shadow-xsmall p-20 p-24-768 round-8 round-8-768 profile-instruction">
          <img src="assets/images/id-card.svg" alt="profile-doc-icon" class="profile-instruction-image">
          <div class="d-flex flex-column gap-10 gap-10-768">
            <h4 class="heading4-768 heading4 font-semibold text-black">ID updates</h4>
            <p class="open-sans paragraph-Medium paragraph-Medium-768 text-black">Once your ID has been verified, some details can no longer be changed. If you need to make updates after verification, please contact the test centre where you booked your test.</p>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showChangePassword) {
    <div class="landing-container d-flex flex-column p-24 gap-24 change-password-landing">
      @if (!hideBackButton) {
        <div class="back-btn-sticky">
          <a (click)="closeChangePassword()" class="txt-baseBlue600 d-flex gap-8 align-items-center cursor-pointer">
            <img src="/assets/images/chevron-left.svg" alt="chevron-left" class="chevronLeft">
            <span class="paragraph-extra-Medium-768 paragraph-extra-Medium font-medium">Back</span>
          </a>
        </div>
      }
      <div class="d-flex flex-column align-items-center justify-content-center change-password-container">
        <app-change-password (onBack)="closeChangePassword()" (onPasswordUpdated)="hideBackButton = $event"></app-change-password>
      </div>
    </div>
  }
  @if (showDeleteAccount && !deleteAccountSuccess) {
    <div class="delete-confirm-container d-flex flex-column gap-48 gap-48-768 px-48-768 py-40-768 pt-32 px-24">
      <div class="px-162-768">
        <a (click)="closeDeleteAccount()" class="txt-baseBlue600 d-flex gap-8 align-items-center cursor-pointer">
          <img src="/assets/images/chevron-left.svg" alt="chevron-left" class="chevronLeft">
          <span class="paragraph-extra-Medium-768 paragraph-extra-Medium font-medium">Back</span>
        </a>
      </div>
      <div class="d-flex flex-column align-self-center justify-content-center delete-account-container">
        <div>
          <app-confirmation-action
            icon="/assets/24_icons/warning_Triangle.svg"
            iconBgColor="transparent"
            title="Important!"
            description="If you are booked for an upcoming IELTS test, do not delete your data as this will result in your booking being cancelled and all your data deleted. Are you sure you wish to proceed?"
            cancelLabel="Cancel"
            confirmLabel="Yes, delete my account"
            (onConfirm)="deleteAccount()"
            (onCancel)="closeDeleteAccount()">
          </app-confirmation-action>
        </div>
      </div>
    </div>
  }
  @if (deleteAccountSuccess) {
    <div class="delete-confirm-container d-flex flex-column gap-48 gap-48-768 px-48-768 py-40-768 pt-32 px-24">
      <div class="d-flex flex-column align-self-center justify-content-center delete-account-container">
        <div>
          <app-confirmation-action
            icon="/assets/24_icons/send.svg"
            iconBgColor="transparent"
            title="Thank you!"
            description="We've received your request to delete your account. We'll need to confirm some details before we can action this. An email with further detail will be sent to you soon."
            confirmLabel="Done"
            confirmBtnClass="btn-primary-red"
            [showCancel]="false"
            (onConfirm)="doneDeleteAccount()">
          </app-confirmation-action>
        </div>
      </div>
    </div>
  }
</section>